import React, { useMemo } from "react"
import { StyleObject } from "styletron-react"
import { colors, fonts, frames } from "../Styles"

import { SystemData } from "../Assets/TestData/systems"
import AttentionListItem from "./AttentionComponents/attentionListItem"
import { AttentionTypes } from "../Definitions"
interface StatusList_Props {
    overrides?:{
        gridArea?: string
    }
  }

export default function StatusList({overrides}:StatusList_Props) {
    const _Root = useMemo<StyleObject>(() => {
        return Object.assign(
            {} as StyleObject, //default style
            overrides&&overrides.gridArea? {gridArea:overrides.gridArea} : {}
        )
      },[overrides])
    
    return(
        <frames.SystemMenu $style={_Root}>
            <div style={{display: "flex", flexDirection: "column", gap: "10px", height: "100%", width: "100%"}}>
              {SystemData.map((system) => (
                <AttentionListItem key={system.systemId} attentionType={system.systemAttention} systemContent={
                  <div>
                    <p style={{...fonts.header, ...fonts.fontSize4, color: colors.greyLightTertiary}}>{system.systemName}</p>
                    <p style={{...fonts.paragraph, ...fonts.fontSize4, color: colors.greyPrimary}}>{system.systemType}</p>
                  </div>
                }/>
              ))}
            </div>
        </frames.SystemMenu>

    )
}